import { ModificatorGenqlSelection } from "@/gql/gen";

export const ModificatorFields: ModificatorGenqlSelection = {
    ID: true,
    NAME: true,
    ACTIVE: true,
    GROUP_CODE: true,
    CODE: true,
    CODE_PATH: true,
    ID_PATH: true,
    TYPE: true,
    LIMIT: true,
    QUANTITY_LIMIT: true,
    IS_GLOBAL: true,
    ORDER_PRICE_FROM: true,
    FEATURES: true,
    CONDITION: {
        PAYMENT_TYPE: true,
        TRANSPORT_TYPE: true,
        PRODUCT_SECTION: true,
        PRODUCT: true,
        OFFICE_ROLE: true,
        OFFICE: true,
        ORDER_PRICE_FROM: true,
    },
    PREVIEW_PICTURE: {
        __fragment: 'Image'
    },
    REQUIRED: true,
    PRODUCT_COMPONENT: true,
    PRODUCT_COMPONENT_PROPS: true,
    PRODUCT_COMPONENT_STYLE: true,
    IBLOCK_SECTION_ID: true,
    DEFAULT_VALUE: true,
    POSITIONS: true,
    OPTION_INFO_TYPE: true,
    OPTIONS: {
        UID: true,
        PRODUCT_ID: true,
        QUANTITY: true,
        QUANTITY_LIMIT: true,
        NAME: true,
        IMAGE: {
            __fragment: 'Image'
        },
    }
}
